import moment from "moment";

import React, { useRef, useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';

import PaginationListHOC from "../HOC/PaginationListHOC";
import { aboutusPhilosophyimg, contentimg, image_thumbnail, loaderIcon, new_image_thumbnail, roomImg } from "shared/images/images";
import { closeicon, HeartPlusIcon, LeftArrow, RightArrow, emptyStar, RightArrowLine, searchIcon, openSearchIcon, filter } from "shared/assets/icons";
import { Loader } from "shared/hoc/loader/Loader";
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";
import CategoryFilter, { SortingItem, KeywordSerach } from "../HOC/CategoryFilter";
import { CategoryService, LocationService, SalesService } from "shared/services";

import './EstateSaleByCategory.scss';

const hidefilter = ["locationid", "zipcode", "distance", "startdate", "enddate","completed","keyword"]
const area = ["Living Room", "Kitchen & Dining", "Office", "Bedroom", "Garage", "Entertainment Cave", "Laundry Storage", "Patio & Lawn", "Barn", "Kids Playroom"]
let pageSize = 48
export default function EstateSaleByCategory(props) {
    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const userData = useSelector(state => state?.user);
    const containerRef = useRef(null);
    const [saleDetail, setsaleDetail] = useState({})
    const [locDetail, setlocDetail] = useState({})
    const [isFavLoc, setisFavLoc] = useState(false)
    const [filterData, setfilterData] = useState({})
    const [totalrecord, settotalrecord] = useState(null)
    const [itemImg, setitemImg] = useState([])
    const [pageload, setpageload] = useState(true)
    const [disableUI, setdisableUI] = useState(false)
    const [signupModal, setsignupModal] = useState(false)
    const [favloader, setfavloader] = useState(false)
    const [roomcount, setroomcount] = useState({})
    const sortval = useRef([{ "field": "itemclosetime", "direction": "asc" }])
    const [viewModal, setviewModal] = useState(false)
    const [windowwidth, setwindowwidth] = useState(window?.innerWidth)
    const [searchText, setSearchText] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [sortvalue , setSortValue] = useState('itemclosetime___asc')
    const [resetKey, setResetKey] = useState(false);

    const handleserach = (event) =>{
        if(event.target.value == ''){
            let pusttoStore = { ...statemaintenance }
        pusttoStore["EstateItemList"] = {
            ...pusttoStore?.["EstateItemList"],
            searchText: event.target.value,
        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        }
        setSearchText(event.target.value)
      }

      useEffect(() => {
        if (searchText === "") {
          getitems(filterData);
          getCounts(params?.saleId, searchText, filterData)
        }
      }, [searchText])

    const params = useParams();
    const [configeredData, setconfigeredData] = useState({})
    useEffect(() => {
        if(saleDetail?.locationid && userData?.id) {

            getFavLoc(saleDetail?.locationid)
        }
    }, [userData,saleDetail?.locationid])
    
    useEffect(() => {
        if (totalrecord == 0 && Object.keys(filterData).length <= 0) {
            setdisableUI(true)
        } else {
            setdisableUI(false)
        }

        return () => {
        }
    }, [totalrecord])

    useEffect(() => {
        window.addEventListener('resize', (resp) => {
            setwindowwidth(window?.innerWidth)
        });

        getApiData()

        return () => {
            window.removeEventListener('resize', (resp) => {
                setwindowwidth(window?.innerWidth)
            });
         }
    }, [])
    const getApiData = () => {
        setpageload(true)
        const saleDetailData = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "itemimageurl", "url", "locationid"],
            // filter: [{ "field": "id", "value": params?.saleId, "op": "=", "join": "AND" }],
            // "page": { "size": 1 }
        };
        getCounts(params?.saleId)
        SalesService.getSaleDetails(params?.saleId,saleDetailData).then((response) => {
            let saleDetail = response?.data?.data?.[0] || {}
            setitemImg(JSON.parse(saleDetail?.itemimageurl) || [])
            setsaleDetail(saleDetail)
            getSaleImage(saleDetail)
            let filter = {}
            let searchTextFromState = '';
            let sortFromState = [{ "field": "itemclosetime", "direction": "asc" }];
            if (statemaintenance?.["EstateItemList"]) {
                filter = statemaintenance?.["EstateItemList"]?.filtervalue || {};
                // sortval.current = statemaintenance?.["EstateItemList"]?.sort || sortval.current
                sortFromState = statemaintenance?.["EstateItemList"]?.sort || sortFromState;
                searchTextFromState = statemaintenance?.["EstateItemList"]?.searchText || '';
            }
            sortval.current = sortFromState;
            let combinedSort = `${sortFromState[0]?.field}___${sortFromState[0]?.direction}` || 'itemclosetime___asc';
            // if(statemaintenance?.["EstateItemList"]?.sort[0]?.field){
            //     combinedSort = `${statemaintenance?.["EstateItemList"]?.sort[0]?.field}___${statemaintenance?.["EstateItemList"]?.sort[0]?.direction}`;
            // }
            // const setSortValues =  combinedSort || 'itemclosetime___asc'
            setSortValue(combinedSort)
            setSearchText(searchTextFromState)
            setfilterData(filter)

            getitems(filter)
            getCounts(params?.saleId, searchTextFromState, filter)
        }).catch((err) => {
            setpageload(false)
        })
    }

    const getCounts = (id, keyword = null, filter = null) => {
        
        keyword = (keyword !== null && keyword !== undefined && keyword !== '') ? keyword : null;
        const filters = [];

        filters.push(
            { field: "salestatus", value: "Started", op: "=", join: "AND" },
            { field: "itemstatus", value: "Ready", op: "=", join: "AND" }
        );

        if (id !== null && id !== undefined) {
            filters.push({ field: "saleid", value: id, op: "=", join: "AND" });
        }
        
        if (filter !== null) {
            if (filter.categoryGroup !== undefined && filter.categoryGroup !== '') {
                filters.push({ field: "categoryGroup", value: filter.categoryGroup, op: "=", join: "AND" });
            }
            if (filter.category !== undefined && filter.category !== '') {
                filters.push({ field: "category", value: filter.category, op: "=", join: "AND" });
            }    
            if(keyword !== undefined && keyword !== null) {
                filters.push({ field: "keyword", value: keyword});
            }
            if (filter.min !== undefined && filter.min !== '') {
                filters.push({ field: "minBidPrice", value: filter.min, op: ">=", join: "AND" });
            }
            if (filter.max !== undefined && filter.max !== '') {
                filters.push({ field: "maxBidPrice", value: filter.max, op: "<=", join: "AND" });
            }
            if (filter.itemtype && Array.isArray(filter.itemtype)) {
                filter.itemtype.forEach(itemstatus => {
                    if (itemstatus === "buynow") {
                        filters.push({ field: "buynowprice", value: 0, op: ">", join: "AND" });
                    } else if (itemstatus === "isshippable") {
                        filters.push({ field: "isshippable", value: 1, op: "=", join: "AND" });
                    } else if (itemstatus === "pickuponly") {
                        filters.push({ field: "isshippable", value: 0, op: "=", join: "AND" });
                    } else {
                        const itemtypeMap = { auction: 2, directBuy: 1, onSite: 3 };
                        filters.push({ field: "itemtypeid", value: itemtypeMap[itemstatus], op: "=", join: "AND" });
                    }
                });
            }
        }
        const count = { filter: filters };
        
        CategoryService.getAreaCount(count).then((response) => {
            let data = {}
            if(response?.data?.data?.length > 0) {
                response?.data?.data.map((item)=>{
                    data[item?.["area"]] = item?.["count"]
                })
            }
            setroomcount(data)
           
        }).catch((err) => {
            setpageload(false)
        })
    }

    const getFavLoc = async(locationId) => {
        if (("id" in userData && userData?.id)) {
            const postData = {
                "sort": [{ "field": "id", "direction": "asc" }],
                "field": ["id", "locationid", "buyerid"],
                filter: [{ "field": "locationid", "value": locationId, "op": "=", "join": "AND" }],
                "page": { "size": 999 }
            };
           await LocationService.getFavoriteLocation(postData).then(res => {
                setisFavLoc(res?.data?.data?.length > 0 || false)
            }).catch(error => {
            });
        }
    }
    const getSaleImage = (saleDetail) => {
        const payload = {
            field:["locationimageurl"],
            "filter": [{ "field": "saleid", "value": saleDetail?.id, "op": "=", "join": "AND" }]
        };
        SalesService.getSaleImagesList(payload).then(async (response) => {
            const imglist = response.data.data?.[0] || []
            const locimg = imglist?.locationimageurl ? imglist?.locationimageurl.split(",") : []
            let locationImage = {}
            locimg.map((image) => {
                image = image.split("#*#")
                locationImage[image[0]] = image[1]
            })
            getLocDetail(saleDetail?.locationid, locationImage)


        }).catch((error) => {
            // getLocDetail(saleDetail?.locationid, {})
            setpageload(false)
        });
    }
    const getLocDetail = (locationId, locationImage) => {
        const locationDetailData = {
            "field": ["id", "locationcode", "locationstatecode", "imageurl", "city", "title","auctioneerlicense"],
            "sort": [{ "field": "title", "direction": "asc" }]
        };
        LocationService.getLocationDetails(locationId, locationDetailData).then(res => {
            let data = res?.data?.data[0]
            setlocDetail({ ...data, ...locationImage })
            setpageload(false)

        }).catch(error => {
            setpageload(false)
        });
    }

    const getitems = async (filterdata, reset) => {
        let filter = []
        Object.keys(filterdata).map(item => {
            if (item in filterdata && filterdata?.[item] != "" && !hidefilter.includes(filterdata?.[item])) {
                switch (item) {
                    case "area":
                        filter.push({ field: "area", value: filterdata?.["area"], op: "=", join: "AND" })
                        break
                    case "min":
                        filter.push({ "field": "bidprice", "value": filterdata?.["min"], "op": ">=", "join": "AND" });
                        break
                    case "max":
                        filter.push({ "field": "bidprice", "value": filterdata?.["max"], "op": "<=", "join": "AND" });
                        break
                    case "startdate":
                        const startdate = moment(filterdata?.["startdate"]).startOf('day').utc();
                        filter.push({ "field": "itemclosetime", "value": startdate.format("YYYY-MM-DD HH:mm:ss"), "op": ">=", "join": "AND" });
                        break;
                    case "enddate":
                        const enddate = moment(filterdata?.["enddate"]).startOf('day').utc();
                        filter.push({ "field": "itemclosetime", "value": enddate.format('YYYY-MM-DD HH:mm:ss'), "op": "<=", "join": "AND" });
                        break;
                    case "itemtype":
                        filterdata?.["itemtype"].forEach(itemstatus => {
                             if (itemstatus == "buynow") {
                                filter.push({ "field": "buynowprice", "value": 0, "op": ">", "join": "AND" });
                            } else if (itemstatus == "isshippable") {
                                filter.push({ "field": "isshippable", "value": 1, "op": "=", "join": "AND" });
                            } else if (itemstatus == "pickuponly") {
                                filter.push({ "field": "isshippable", "value": 0, "op": "=", "join": "AND" });
                            } else {
                                let itemtype = { auction: 2, directBuy: 1, onSite: 3 }
                                filter.push({ "field": "itemtypeid", "value": itemtype[itemstatus], "op": "=", "join": "AND" });
                            }
                        });
                        break
                    default:
                        filter.push({ "field": item, "value": filterdata?.[item], "op": "=", "join": "AND" });
                        break
                }
            }

        })
        var keywords = ''
        if(reset){
            setSearchText(null)
        }else{
            var keywords =   searchText ?  searchText : statemaintenance?.["EstateItemList"]?.searchText 
        }   

       
        if(keywords){
            filter.push({ "field": "title", "value": `%${keywords}%`, "op": "like", "join": "AND" });
        }

        const payload = {
            "sort": sortval.current,
            "page": { "size": pageSize },
            "field": ["id", "displayimageurl", "state", "city", "zipcode", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime",
                "utc", "title", "endtime", "isshippable", "saleid", "category", 'categoryGroup', 'thumbnailurl', 'itemseourl',  "bidprice","itemlistingtime"],
            "filter": [
                ...filter,
                { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                { "field": "saleid", "value": params?.saleId, "op": "=", "join": "AND" },
                // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" },
            ]

        };
        let pusttoStore = { ...statemaintenance }
        pusttoStore["EstateItemList"] = {
            ...pusttoStore?.["EstateItemList"],
            filtervalue:{...filterdata},
            searchText: reset ? '' : searchText,
            sort:sortval.current
        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });

        setconfigeredData({
            payload,
            count: 3,
            pageSize: pageSize,
            type: "Item",
            history: props?.history,
            heading: "EstateItemList"
        })
    }

    const serachKeywords = (show) => {
      setShowModal(show);
    };


    const handle = (key) => {
        const container = containerRef.current;
        if (container) {
            container.scrollTo({
                left: key == "left" ? container.scrollLeft - 200  : container.scrollLeft + 200,
                behavior: 'smooth',
            });
        }
    }
    const addFav = () => {
        if (("id" in userData && userData?.id)) {
            setfavloader(true)
            if(isFavLoc){
                const postData = { data: { locationIds: [{ id: saleDetail?.locationid }] } };
               LocationService.deleteFavoriteLocation(postData).then(async() => { 
                await getFavLoc(saleDetail?.locationid)
                setfavloader(false)
                
               }).catch(() => {
                 setfavloader(false)
               });
            } else { 
                const postData = { "data": { "locationid": saleDetail?.locationid } };
                LocationService.addFavoriteLocation(postData).then(async() => { 
                    await getFavLoc(saleDetail?.locationid)
                    setfavloader(false)
                }).catch(error => {
                    setfavloader(false)
                });
            }
        } else {
            dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        }
    }

    if (pageload)
        return <Loader />

    return (
        <div>
            <Helmet>
                <title>{saleDetail.title}</title>
                <meta name='description' content={saleDetail.provenance} />
                <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
            </Helmet>
            <h1 className='d-none'>{`Estate Sale – ${locDetail?.title ? locDetail?.title  : ''} | CTBids Online Auctions`}</h1>
            <h2 className='d-none'>{saleDetail.title}</h2>
            <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.ESTATE_SALE_ITEM_LIST} options={{ saleId: saleDetail.id, saleTitle: saleDetail.title }} />
            <div className="esc-container">
                <div className="left-view">
                    <div className="location-card">
                        <div className="location-head">
                            <div className="left">
                                <div className="imgcontainer">
                                    <img className="location-img" src={locDetail?.profile || locDetail?.banner || new_image_thumbnail} alt="location image" />
                                </div>
                            </div>
                            <div className="right">
                                <div className="locationtitle"> {locDetail?.title}</div>
                                <div className="locationcity my-2">{locDetail?.city}</div>
                                {locDetail.auctioneerlicense && <div className='text-secondary mt-3' style={{ wordBreak: "break-all" }}>License: {locDetail.auctioneerlicense}</div>}
                               {favloader? <div className="  my-3"><img className="loader-gif" src={loaderIcon} alt="loader-icon"></img></div>: <Button className={` ${isFavLoc ? "favloc" : "nonfav"} my-2`} onClick={() => { addFav() }}>
                                    {HeartPlusIcon}
                                    {/* <i className={`far fa-heart ${isFavLoc ? "text-white" : "text-secondary"}`}></i> */}
                                </Button>}
                            </div>
                        </div>
                        <Button
                            className=' w-100 btn-grey-light  rounded text-bold my-2 d-flex gap-2 justify-content-center align-items-center'
                            onClick={() => {

                                const url = locDetail.locationcode ? `/estate-sales/${locDetail.locationstatecode}/${locDetail.locationcode}` : `/estate-sales/${locDetail.locationstatecode}`;
                                props.history.push(url);
                            }}
                        >
                              <div>View Estate Sales</div>
                               <div > {RightArrowLine}</div>
                        </Button>

                        {/* <Button
                            className=' w-100 btn-grey-light  rounded text-bold my-2 d-flex gap-2 justify-content-center align-items-center''
                            onClick={() => { }}
                        >

                              <div>Show Location Details</div>
                               <div > {RightArrowLine}</div>
                        </Button> */}
                    </div>
                    <div className={`${disableUI ? "disableui" : ""}`} >
                        <CategoryFilter onApply={(filter) => {
                            setfilterData({ ...filterData, ...filter })
                            getitems(filter)
                            getCounts(params?.saleId, searchText !== '' || searchText !== undefined ? searchText : null, filter)
                        }}
                            defaultkey="0"
                            filterData={filterData}
                            hidefilter={hidefilter}
                            viewModal={viewModal}
                            setviewModal={() => { setviewModal(!viewModal) }}
                            defultFilter = {{}}
                            resetFilter={() => {
                            
                                // let area = filterData['area']
                                // setfilterData({area: area})
                                // if( area ){
                                //     setfilterData({area: area})
                                //     getitems({area})
                                    
                                // } else {
                                    setfilterData({})
                                    setResetKey(prev => !prev);
                                    sortval.current = [{ field: "itemclosetime", direction: "asc" }]
                                    getitems({},true)
                                // }
                                setSearchText('');
                                getCounts(params?.saleId, null, null);
                            
                            }} /></div>
                </div>
                <div className="right-view">
                    <div className="sale-detail ">
                        <div className="sale-head">
                            <div>
                                <div className="sale-title">{saleDetail?.title}</div>
                            </div>
                            <div className="d-flex gap-5">
                                <div className="">
                                    <div className="itemdetail-head">Items available</div>
                                    <div className="itemdetail-bot">{totalrecord}</div>
                                </div>
                                <div className="">
                                    <div className="itemdetail-head">Ends on</div>
                                    <div className="itemdetail-bot">{moment.utc(saleDetail?.endtimeutc || saleDetail?.endtime).format("MM/DD/YYYY")}</div>
                                </div>
                            </div>
                        </div>
                        <div className='roomcontanier'>
                            <div role={"button"} className={`roomnavbtn`} onClick={() => { handle("left") }}>{LeftArrow}</div>
                            <div className="roomcintent">
                                <div ref={containerRef} className={`${disableUI ? "disableui" : ""} roomrow`} >                                    
                                    {area?.map((item) => {
                                        const valid = item in roomcount && Number(roomcount[item]) > 0
                                        return (
                                            <Button
                                                className   ={`btn-grey mx-2 d-flex gap-3 ${ !roomcount[item] ? "disabled-room" : filterData?.area === item ? "activeroom" : "" }`}
                                                disabled={!valid || !roomcount[item]}
                                                onClick={() => {
                                                    if (!roomcount[item]) return;
                                                    let filter = { ...filterData };
                                                    if ("area" in filter && filter?.area === item) {
                                                        delete filter?.area;
                                                    } else {
                                                        filter["area"] = item;
                                                    }
                                                    setfilterData(filter);
                                                    getitems(filter);
                                                }} >
                                                <img style={{ tintColor: "red", filter: !roomcount[item] ? "grayscale(100%)" : "",}} src={roomImg[item]} />
                                                {item}
                                                </Button>
                                        );
                                    })}
                                </div>
                                <div className="overlayblur"></div>
                            </div>
                            <div role={"button"} className={`roomnavbtn`} onClick={() => { handle("right") }}>{RightArrow}</div>
                        </div>
                        <div className="sale-coverview">
                            <div className='sale-image-view'>
                                <img
                                    src={saleDetail.url  || saleDetail?.staticcoverimage}
                                    alt="sale-image"
                                    className={`sale-image ${!saleDetail.saleimageurl ? 'no-image' : ''}`}
                                />
                                <div className='itemimagecard shadow image1'><img className={`itemimg `} src={itemImg?.[0] ? itemImg[0] : saleDetail?.staticinsertimage} /></div>
                                <div className='itemimagecard shadow image2'><img className={`itemimg `} src={itemImg?.[1] ? itemImg[1] : saleDetail?.staticinsertimage} /></div>
                                <div className='itemimagecard shadow image3'><img className={`itemimg `} src={itemImg?.[2] ? itemImg[2] : saleDetail?.staticinsertimage} /></div>
                            </div>
                            <div className="content">
                                <div className='provenance'>{saleDetail?.provenance}</div>
                                {/* <div className='message-wrap' dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(saleDetail.termsandconditions) }}></div> */}
                            </div>
                        </div>
                    </div>
                    {!("id" in userData && userData?.id) && <div className="registerUI">
                        <Button onClick={() => {
                              setsignupModal(true)
                            // props?.history?.push("/register")
                        }}>Register & Start Bidding</Button>
                        <div  className="ms-3">Register now to start placing bids on this sale. Already registered? <span role={"button"} onClick={() => {

                            dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
                        }}>Sign in</span> </div>
                    </div>}
                    <div >
                        {windowwidth > 800 ? <div className="d-flex justify-content-center mt-5 align-items-center w-100 gap-3 flex-wrap">
                            {/* Sort By */}
                            <div className="d-flex align-items-end flex-shrink-0">
                                <SortingItem
                                   key={resetKey} 
                                    onApply={(sortData) => {
                                        sortval.current = sortData;
                                        getitems(filterData);
                                    }}
                                    sortvalue={sortvalue}
                                />
                            </div>

                            {/* Search Section */}
                            <div className="d-flex align-items-center" style={{ flexShrink: 0 }}>
                                <div className="search-box-form m-0" style={{ width: '220px' }}>
                                    <div className="search-box">
                                        <div className="input-group" style={{ width: '100%' }}>
                                            <span
                                                className="d-flex input-group-append align-items-center clickable"
                                                style={{ width: "12px", marginLeft: '5px' }}
                                            >
                                                {searchIcon}
                                            </span>
                                            <input
                                                className="form-control"
                                                id="advance-sale-search-input"
                                                aria-label="Search this sale..."
                                                placeholder="Search this sale..."
                                                style={{ padding: '5px' }}
                                                value={searchText}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        getitems(filterData);
                                                        getCounts(params?.saleId, searchText, filterData);
                                                    }
                                                }}
                                                onChange={(event) => handleserach(event)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        color: "#99004C",
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        background: "none",
                                        border: "none",
                                        marginLeft: '8px',
                                    }}
                                    onClick={() => {
                                        getitems(filterData);
                                        getCounts(params?.saleId, searchText, filterData);
                                    }}
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                            :
                            <>
                                <div className="d-flex align-items-end gap-3">
                                    <div className="w-50">
                                        <SortingItem onApply={(sortData) => {
                                            sortval.current = sortData
                                            getitems(filterData)
                                        }} sortvalue={sortvalue} />
                                    </div>
                                    <>
                                        <div className="d-flex align-items-center w-50 flex-column  flex-wrap">

                                            <div className="ms-auto" onClick={() => { setviewModal(!viewModal) }}> {filter}</div>
                                            <button
                                                type="button"
                                                className="btn border w-100"
                                                style={{
                                                    color: "#99004C",
                                                    fontWeight: "bold",
                                                    fontSize: "14px",
                                                }}
                                                onClick={() => serachKeywords(true)}
                                            >
                                                {openSearchIcon} Search
                                            </button>

                                        </div>
                                    </>
                                </div>
                            </>
                        }
                    </div>
                    <PaginationListHOC
                        config={configeredData}
                        emptyCont={
                            <div>
                                {saleDetail.status === "Closed" ?
                                    <div className='d-flex align-items-center flex-column text-center text-secondary'>
                                        <div className='emptyhead'>This sale has now closed. Check out our other sales with unique and everyday treasures.</div>
                                    </div> :
                                    <div className='d-flex align-items-center flex-column text-center text-secondary'>
                                        <div className='emptyhead'>This amazing CTBids auction does not have any listings for&nbsp;
                                            { filterData?.categoryGroup || filterData?.category || filterData?.area  ? 
                                                <>
                                                    {(filterData?.categoryGroup) && `${filterData?.categoryGroup} `} {(filterData?.category) && `/${filterData?.category} `} { ((filterData?.categoryGroup || filterData?.category) && filterData?.area) && "or"} {filterData?.area && ` ${filterData?.area}`}
                                                </> 
                                            : 'ALL.'} </div>
                                        <div className='emptyhead'>Browse other {filterData?.categoryGroup && `categories `}  { ((filterData?.categoryGroup || filterData?.category) && filterData?.area) && "or"}  {filterData?.area && `rooms`} in this estate sale now! </div>
                                    </div>}
                            </div>
                        }
                        onRestCall={(total) => {
                            settotalrecord(total)
                        }}
                        showAd
                    />
                </div>
            </div>

            <Modal centered show={showModal} size="sm" animation={false} backdrop="static" keyboard={false} Hide={() => setShowModal(false)}>
                <Modal.Body>
                    <div className="">
                        <div className="search-box-form m-0">
                            <div className="search-box">
                                <div className="input-group" style={{ width: "100%" }}>
                                    <span
                                        className="d-flex input-group-append align-items-center clickable"
                                        style={{ width: "12px", marginLeft: '5px' }}
                                    >
                                        {searchIcon}
                                    </span>
                                    <input
                                        className="form-control "
                                        id="advance-sale-search-input"
                                        aria-label="Search this sale..."
                                        placeholder="Search this sale..."
                                        style={{ padding: '5px' }}
                                        value={searchText}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                              getitems({});
                                              getCounts(params?.saleId, searchText, filterData);
                                              setShowModal(false);
                                            }
                                          }}                                        
                                          onChange={(event) => handleserach(event)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex gap-3 w-100 align-item-center justify-content-center mt-3">
                            
                        <Button
                            type="button"
                            className="outline-primary w-50"
                            
                            style={{color: '#00263E', backgroundColor: '#868E961A', borderColor:'#868E961A'}}
                            onClick={() => setShowModal(false)}
                        >
                            Cancel
                        </Button>

                        <Button
                            type="button"
                            className="btn"
                            variant="secondary w-50 ml-10"
                            onClick={() => { getitems({}); getCounts(params?.saleId, searchText, filterData); setShowModal(false);}}
                        >
                            Search
                        </Button>

                        </div>

                    </div>
                </Modal.Body>
            </Modal>

            <Modal id="registermodal-estatesale"centered show={signupModal} size="lg" animation={false} backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="estate-register-modal">
                        <button className="closebtn clickable" onClick={()=>{setsignupModal(false)}}>{closeicon}</button>
                        <div className="estate-register-container">
                            <div className="register-head">Register for a CTBids Account</div>
                            <div className="register-content">We are not like other sites. CTBids is powered by Caring Transitions as part of a total solution for our clients. Caring Transitions owners are the sellers, working with local clients who have a need to downsize, liquidate and sell treasures they no longer have use for. Bidding starts at $1, and most sales run for 7 to 14 days.</div>
                            <div className="flex-view">
                                <div className="right-cont">
                                    <div className="d-flex gap-2 p-2 align-items-center">
                                        <div >{emptyStar}</div>
                                        <div className="cont-txt">Supported by Caring Transitions</div>
                                    </div>
                                    <div className="d-flex gap-2 p-2 align-items-center">
                                        <div >{emptyStar}</div>
                                        <div className="cont-txt">Proxy bidding feature</div>
                                    </div>
                                    <div className="d-flex gap-2 p-2 align-items-center">
                                        <div >{emptyStar}</div>
                                        <div className="cont-txt">24/7 available helpdesk</div>
                                    </div>
                                    <div className="d-flex gap-2 p-2 align-items-center">
                                        <div >{emptyStar}</div>
                                        <div className="cont-txt">Real time bid status notification</div>
                                    </div>
                                </div>
                                <div className="img-container">
                                    <img src={aboutusPhilosophyimg} className="register-content-img" alt="register-content-img" />
                                </div>
                            </div>
                            <Button className="btn-secondary w-100" onClick={() => {
                                setsignupModal(false)
                                props?.history?.push("/register")
                            }}>Register Now</Button>
                            <div className="btm-sign-cont">Already have an account? <span className="signin clickable" onClick={() => {
                                setsignupModal(false)
                                dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });

                            }} > Sign in</span></div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}